import * as tslib_1 from "tslib";
import { IgrDefinitionBase } from "./igr-definition-base";
import { PinnedAreaSeparator } from "./PinnedAreaSeparator";
var IgrPinnedAreaSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrPinnedAreaSeparator, _super);
    function IgrPinnedAreaSeparator(props) {
        return _super.call(this, props) || this;
    }
    IgrPinnedAreaSeparator.prototype.createImplementation = function () {
        return new PinnedAreaSeparator();
    };
    Object.defineProperty(IgrPinnedAreaSeparator.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    return IgrPinnedAreaSeparator;
}(IgrDefinitionBase));
export { IgrPinnedAreaSeparator };
//# sourceMappingURL=igr-pinned-area-separator.js.map
